import './products.scss'

import {
	BannerCampaign,
	BannerCta,
	BannerCustomType
} from 'views/campagne/partials/banner'
import {ImageType, LinkBaseType} from 'campagne/types'
import React, {FunctionComponent} from 'react'

import {Layout} from 'views/campagne/layout'
import {Theme} from 'views/campagne/theme'
import {style} from 'util/campagne/style'
import {wrap} from '@codeurs/front'

const styles = style('products')

export type ProductsType = {
	title: string
	banners: Array<BannerCustomType>
	products: Array<ProductType>
}

type ProductType = {
	link: LinkBaseType
	description: string
	image: ImageType
	title: string
}

export const Products: FunctionComponent<ProductsType> = wrap(Layout)(
	({banners, products, banner: giftBanner, ...rest}) => {
		const {title1, title2, text, link, ...gift} = giftBanner
		const firstBanners = banners.slice(0, 2).filter(Boolean)
		const secondBanners = banners.slice(2).filter(Boolean)

		return (
			<div class={styles}>
				{firstBanners.length > 0 && (
					<div class={styles('banner')}>
						<Theme.Container>
							{firstBanners.map((banner) => (
								<BannerCampaign {...banner} />
							))}
						</Theme.Container>
					</div>
				)}
				{secondBanners.length > 0 && (
					<div class={styles('banner')}>
						<Theme.Container>
							{secondBanners.map((banner) => (
								<BannerCampaign {...banner} />
							))}
						</Theme.Container>
					</div>
				)}
				<div class={styles('banner')}>
					<Theme.Container>
						<BannerCta
							headingLeft={title1}
							headingRight={title2}
							description={text}
							ctaLink={link}
							{...gift}
						/>
					</Theme.Container>
				</div>
			</div>
		)
	}
)
